var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmptystateRoutepending = function SvgEmptystateRoutepending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 6c0 3-4 6-4 6S6 9 6 6a4 4 0 0 1 8 0zm-2.5-.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 11.5 5.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.602 12.798.004-.003.012-.009.04-.031.141-.111a16.619 16.619 0 0 0 2.202-2.148V18l-6-2v-5.503a16.76 16.76 0 0 0 2.343 2.259l.04.031.012.009.004.003.6.451.602-.452zM14 18V9.123c.45-.736.817-1.565.948-2.439l3.736-1.245A1 1 0 0 1 20 6.387v8.892a1 1 0 0 1-.684.949L14 18zM5 6c0-.231.016-.459.046-.682L.684 6.772A1 1 0 0 0 0 7.721v8.892a1 1 0 0 0 1.316.949L6 16V9.123C5.434 8.197 5 7.125 5 6z"
  })));
};
export default SvgEmptystateRoutepending;